export default "__VITE_ASSET__BcnB_ITD__"